module.exports = __webpack_public_path__ + "img/viewpoint-360-logo--white.a9355b9a.png";